// Added by Jonghyung Lee on 2022-02-17
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { makeAutoObservable } from 'mobx'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Root Store
import RootStore from '../../index'

// Services
import { reqGetPacsQRList, reqPostRestartPacsQR } from '@/service/pacsqr.service'
import { PACSQRInterface } from '@/helper/define/pacsqrDefine'

export default class PacsQRStore {
  _elements: PACSQRInterface[] = []
  root?: RootStore

  constructor(root: RootStore) {
    this.root = root
    makeAutoObservable(this)
  }

  getElements = async (path: string) => {
    const {
      data: { items, total_count },
    } = await reqGetPacsQRList(path)
    this._elements = items ?? []
    return { pacsqr: this._elements, totalCnt: total_count }
  }

  restartTask = async (id: string) => {
    await reqPostRestartPacsQR(id)
  }
}
